import React from 'react'
import { Link } from 'react-router-dom';
import Image from '../Image';

const ServiceItem = (props) => {
    const {image, title, comment, url, ButtonTitle} = props;
  return (
    <div className="project-services">
                        <div className="project-services-img">
                            <Image className="img-fluid center-block transition" image={image} />
                        </div>
                        <div className="project-services-content">
                            <h3 className="h3-antwerp-semibold">{title}</h3>
                            <p >{comment}</p>
                            <Link to={url} className="btn btn-grey-border text-uppercase">{ButtonTitle}</Link>
                        </div>
                    </div>
  )
}

export default ServiceItem